import { atom } from "jotai";

 export const entrevistasAtom= atom([]);